/**
 * User: liliana
 * Date: 12/18/13
 * Time: 2:13 PM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */
'use strict';

var $              = require('dibs-jquery-shim');
var mobileCheck    = require('bunsen/helpers/mobileCheck');
var pointerEvents  = require('global/modules/pointerEvents');

require('thirdParty/pointerevents');

var hasTouch            = mobileCheck.hasTouch();
var hasPointerEvents    = !!global.PointerEvent;
var doubleTapCompleted  = false;
var $body;

// no other file really consumes this stuff...
module.exports = {
    tapClass: 'js-tap-events',
    tapDropDownClass: 'js-tap-dropdown',
    events: {},
    touchEvents: {
        start  : 'touchstart.tapVsSwipe',
        move   : 'touchmove.tapVsSwipe',
        end    : 'touchend.tapVsSwipe',
        click  : 'click.tapVsSwipe'
    },
    pointerEvents: {
        start  : 'pointerdown.tapVsSwipe',
        move   : 'pointermove.tapVsSwipe',
        end    : 'pointerup.tapVsSwipe',
        click  : 'click.tapVsSwipe'
    },
    getCoords: function (e) {
        return {
            pageX: e.originalEvent.pageX,
            pageY: e.originalEvent.pageY
        };
    },
    setupEvents: function () {
        this.events = hasPointerEvents ? this.pointerEvents : this.touchEvents;
    },
    /**
     * Add a "Tap" event to an element. We define tap as a touch event that starts and end within
     * the specified threshold, a distance in pixels. (as opposed to a swipe, which goes outside of it).
     *
     * @param {jQuery} $element The jQuery element that the event should be hooked up to.
     * @param {number} [threshold=10] The threshold distance between the coordinates of the touch events. Optional.
     * @param {function} [callback] The callback function called after the end of a swipe. Optional.
     */
    addEvent: function ($element, threshold, callback) {
        var lastTouch = null;
        var firstTouch = null;
        var self = this;

        if (arguments.length === 2) {
            if (typeof threshold === 'function') {
                callback = threshold;
            }
        }

        threshold = typeof threshold === 'number' ? threshold : 10;

        // add touch action attribute to receive pointer events
        if (hasPointerEvents) {
            $element.data(pointerEvents.TOUCH_ACTION_ATTR, pointerEvents.TOUCH_ACTION_NONE);
        }

        $element
            .addClass(self.tapClass)
            .on(self.events.start, function (e) {
                firstTouch = self.getCoords(e);
            })
            .on(self.events.move, function (e) {
                lastTouch = self.getCoords(e);
            })
            .on(self.events.end, function (e) {
                if (lastTouch && firstTouch) {
                    if ((Math.abs(firstTouch.pageX - lastTouch.pageX) > threshold) ||
                        (Math.abs(firstTouch.pageY - lastTouch.pageY) > threshold)) {

                        // do stuff on swipe
                        // a swipe callback can be implemented here if we change the function signature

                        lastTouch = null;
                        firstTouch = null;
                        return;
                    }
                }

                lastTouch = null;
                firstTouch = null;

                if (callback) {
                    callback(this, e); //keep the scope jq callbacks usually have, and pass the event
                    return false;
                }

            });
    },
    /**
     * Removes the touch events added by the addTapEvents() function. Using this function ensures that only
     * the specific events are removed, and not any other touch events the elements may have.
     *
     * @param {jQuery} $element jQuery element with touch events originally added from AddTapEvents()
     */
    removeEvent: function ($element) {
        // remove touch action attribute to stop receiving pointer events
        if (hasPointerEvents) {
            $element.removeData(pointerEvents.TOUCH_ACTION_ATTR);
        }
        $element
            .off(this.events.start)
            .off(this.events.move)
            .off(this.events.end);
    },

    clearAllEvents: function ($wrapper, $element) {
        var self = this;
        var els = [
            $element,
            $wrapper,
            $body
        ];

        for (var i in els) {
            if (els.hasOwnProperty(i)) {

                self.removeEvent(els[i]);
                els[i]
                    .off(this.events.click)
                    .removeClass(self.tapClass);
            }
        }
    },
    /**
     * Binds "Tap" event to dropdown on touch devices to toggle dropdown visibility by adding and removing a
     * class instead of using the :hover psuedoclass
     *
     * @param {jQuery} $wrapper The jQuery ancestor element that wraps around all dropdowns
     * @param {string} container A class selector that contains the dropdowns
     * @param {object} [elsToIgnore=''] An object of children element(s) to ignore when binding tap events. Optional.
     * @param {string} [klass='is-tap'] The class that is toggled to show and hide dropdowns. Optional.
     */
    bindToDropDowns: function ($wrapper, container, elsToIgnore, klass) {
        var self = this;
        // the link that was just clicked. initially starts out as nothing on page load.
        var $curItem = [];
        var target = container;

        if (arguments.length === 3) {
            if (typeof elsToIgnore === 'string') {
                klass = elsToIgnore;
                elsToIgnore = [];
            }
        }
        target = target + ':not(' + elsToIgnore.selector + ')';
        klass = klass || 'is-tap';

        if (hasTouch) {
            $wrapper
                .on(self.events.click, target, function () {
                    // don't prevent click if:
                    // 1. dropdown has hover class, i.e. user is hovering with mouse, and
                    // 2. doubleTapComplete is true, otherwise navigation gets cancelled
                    if (!$(this).parent().hasClass('is-hover') && !doubleTapCompleted) {
                        return false;
                    }
                    // reset in case user clicks stop
                    if (doubleTapCompleted) {
                        doubleTapCompleted = false;
                    }
                })
                .on(self.events.start, target, function () {
                    var $this = $(this);
                    var hasTapEvents = $this.hasClass(self.tapClass); // bind tap events once!

                    // FINDING-2822 first click shows dropdown, second click navigates to vertical
                    // logic grabbed from doubleTapToGo plugin:
                    // http://osvaldas.info/examples/drop-down-navigation-touch-friendly-and-responsive/
                    if (!hasTapEvents) {

                        self.addEvent($this, function (el) {
                            if (!hasPointerEvents || !$(el).parent().hasClass('is-hover')) {
                                var $item = $(el);
                                var href = $item.attr('href');
                                // var target = $item.attr('target') === '_blank' ? '_blank' : '_self';
                                var enableDoubleTapAction = $item.hasClass('js-double-tap');
                                var isValidUrl = href && !(/^#/).test(href);

                                // FINDING-2822 add class to enable hover states instead of relying on :hover psuedoclass
                                $item.parent().addClass(klass);

                                if (!$item.is($curItem)) {
                                    // link has only been tapped once
                                    $curItem = $item;
                                } else {
                                    // second tap happens, go to link
                                    if (enableDoubleTapAction && isValidUrl) {
                                        doubleTapCompleted = true;
                                        location.assign(href);
                                    }
                                    // reset current item on second tap
                                    $curItem = [];
                                }
                                // allow links to clickthrough for slide-in global nav
                                if (!enableDoubleTapAction && isValidUrl) {
                                    location.assign(href);
                                }
                            }
                        });
                    }
                });

            if (!$body.hasClass(self.tapClass)) {
                $body.on(self.events.click + ' ' + self.events.start, function (e) {
                    if (!hasPointerEvents || (e.pointerType && !pointerEvents.isMouse(e))) {
                        var $target = $(e.target);
                        var hasTapEvents = $target.hasClass(self.tapClass);
                        var hasTapDropDown = $curItem.length ? $curItem.hasClass(self.tapDropDownClass) : false;
                        var resetItem;
                        var $parent;
                        var href;

                        $body.addClass(self.tapClass);

                        // reset current item when clicked on dropdown item that does not result in page refresh
                        if (hasTapDropDown) {
                            $curItem.removeClass(self.tapDropDownClass);
                            $curItem = [];
                        }
                        if ($curItem.length) {
                            resetItem = false;
                            $parent = $curItem.parent();

                            if ($parent.find($target).length === 0) {
                                // click occurs outside of dropdown
                                $parent.removeClass(klass);
                                resetItem = true;
                            } else {
                                // removes tap class when link is clicked in dropdown or after double tap
                                // ensures element is always hidden even when body loses focus i.e. iframes
                                setTimeout(function () {
                                    $parent.removeClass(klass);
                                }, 500);
                                // click occurs in dropdown, add dropdown tap class
                                if ($curItem.find($target).length === 0 && !$curItem.is($target)) {
                                    $curItem.addClass(self.tapDropDownClass);
                                    // capture href and force clickthrough when clicking on link in dropdown on touch
                                    href = $target.attr('href');
                                    if (href) {
                                        location.assign(href);
                                    }
                                }
                            }
                            // tap occurred outside of the current item, reset current item
                            if (resetItem) {
                                $curItem = [];
                            }
                        }
                        if (hasTapEvents) {
                            return false;
                        }
                    }
                });
            }
        }
    },
    init: function initTapEvents() {
        var self = this;
        var container = '.sub-nav-parent > a';
        var elsToIgnore;
        // [href=#search] is excluded because its visibility is toggled on click not on hover
        elsToIgnore = { selector: '[href=#search]' };
        $body = $('body');

        this.setupEvents();
        this.bindToDropDowns($body, container, elsToIgnore);

        $.subscribe('page:updated', function () {
            self.clearAllEvents($body, $(container).not(elsToIgnore.selector));
            self.bindToDropDowns($body, container, $(elsToIgnore.selector));
        });
    }
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/utils/commonjs/tapEvents.js
// module id = 2584
// module chunks = 64